import React, { useEffect, useState } from "react";
import Common_Report_Offcanvas from "../../../../common_report_offcanvas/Common_Report_Offcanvas";
import Accuracy_Report_Filter from "./accuracy_report_filter/Accuracy_Report_Filter";
import Accuracy_Report_Table from "./accuracy_report_table/Accuracy_Report_Table";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAccuracyReport,
  GetCustomerReport,
} from "../../../../../../../features/admin/report_generator/Slice";
import { GetAll } from "../../../../../../../features/admin/quality_management/process_requirement/accuracy/Slice";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Accuracy_Report = () => {
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const accuracydetails = useSelector((state) => state.accuracy);
  const [searchParams, setSearchParams] = useState({
    test_type_id: null,
    checked_by_id: null,
    certified_value: "",
    end_date: "",
    start_date: "",
  });

  const permissions = useSelector((state) => state.auth.permissions);
  const haveReportPermission = permissions?.includes(FixIDS.accuracy_report.Report);
  

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: accuracydetails?.per_page,
        verification_type_id: searchParams?.verification_type_id?.value,
        certified_value: searchParams?.certified_value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetAccuracyReport({
        page: 1,
        per_page: accuracydetails?.per_page,
        verification_type_id: searchParams?.verification_type_id?.value,
        certified_value: searchParams?.certified_value,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <Accuracy_Report_Filter
          setShow={setShow}
          reportgenerate={reportgenerate}
          setSearchParams={setSearchParams}
          searchParams={searchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <Accuracy_Report_Table
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          accuracydetails={accuracydetails}
        />}
      </div>
      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Accuracy Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Accuracy_Report;
